export const ROL_ADMINISTRADOR = 1;
export const ROL_USUARIO_BARRIO = 2;
export const ROL_PORTERO = 3;
export const ROL_SUPERADMIN = 4;
export const ROL_PERFIL_ADMINISTRADOR = 5;

export const ROLES = [
    { label: 'Administrador', value: ROL_ADMINISTRADOR },
    { label: 'Usuario Barrio', value: ROL_USUARIO_BARRIO },
    { label: 'Portero / Encargado', value: ROL_PORTERO },
    { label: 'Superadmin', value: ROL_SUPERADMIN },
    { label: 'Perfil Administrador', value: ROL_PERFIL_ADMINISTRADOR },
];
